<mat-dialog-actions fxLayoutAlign="flex-end">
  <ng-content></ng-content>
</mat-dialog-actions>
